export class CompanyDomainApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCompanyDomains({ companyId, type }) {
    return this.#http.get(`/api/companies/${companyId}/domains`, {
      ...(type && { params: { type } }),
    });
  }

  async createCompanyDomain({ companyId, ...body }) {
    return this.#http.post(`/api/companies/${companyId}/domains`, body);
  }

  async deleteCompanyDomain({ companyId, domainName }) {
    return this.#http.delete(
      `/api/companies/${companyId}/domains/${encodeURIComponent(domainName)}`,
    );
  }

  // A verify 404 is surfaced to the user (not silently swallowed) — see DomainsSection.js and
  // CustomDomainsTab.js onVerify.
  async verifyCompanyDomain({ companyId, domainName }) {
    return this.#http.post(
      `/api/companies/${companyId}/domains/${encodeURIComponent(domainName)}/verify`,
    );
  }
}
